const homeKey = 'orimodo-home-scroll-v1';
const returnKey = 'orimodo-home-return-v1';
const isHome = document.body.dataset.orimodoTemplate === 'index';
const read = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
if (isHome) {
  let navigationSaved = false;
  const restoreHome = () => {
    if (read(returnKey) !== '1') return;
    write(returnKey, '0');
    const top = Math.max(0, Number(read(homeKey)) || 0);
    requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo({ top, behavior: 'instant' })));
  };
  if (document.readyState === 'complete') restoreHome();
  else window.addEventListener('load', restoreHome, { once: true });
  window.addEventListener('pageshow', () => { navigationSaved = false; });
  window.addEventListener('pagehide', () => {
    if (!navigationSaved) write(homeKey, String(window.scrollY));
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link?.target === '_blank' || link?.hasAttribute('download')) return;
    if (link && link.origin === location.origin && link.pathname !== location.pathname) {
      navigationSaved = true;
      write(homeKey, String(window.scrollY));
    }
  }, true);
} else {
  document.querySelectorAll('a.header-logo,a.opd-logo').forEach(link => link.addEventListener('click', () => write(returnKey, '1')));
}
document.querySelectorAll('.orimodo-carousel__alternate').forEach(video => {
  const syncRatio = () => {
    const media = video.closest('.orimodo-carousel__media');
    if (media && video.videoWidth && video.videoHeight) media.style.aspectRatio = `${video.videoWidth} / ${video.videoHeight}`;
  };
  video.addEventListener('loadedmetadata', syncRatio);
  syncRatio();
});
